<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-tabs v-if="hot && !routeRegion" v-model="selectedRegion" @change="load">
        <a-tab-pane :key="1" tab="国内" />
        <a-tab-pane :key="2" tab="国外" />
      </a-tabs>
      <a-form layout="inline" class="bar">
        <a-form-item label="关键词"><a-input v-model="query.keyword" allow-clear /></a-form-item>
        <a-form-item v-if="!hot" label="国内/国外">
          <a-select v-model="query.region" allow-clear style="width:120px">
            <a-select-option :value="1">国内</a-select-option>
            <a-select-option :value="2">国外</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="load">查询</a-button>
          <a-button v-if="hot" class="ml" type="primary" @click="openAdd">新增热搜词</a-button>
        </a-form-item>
      </a-form>
      <a-table
        row-key="rowKey"
        :loading="loading"
        :data-source="rows"
        :columns="columns"
        :pagination="false"
        bordered>
        <template slot="region" slot-scope="t,r"><a-tag :color="Number(r.region) === 2 ? 'purple' : 'blue'">{{ Number(r.region) === 2 ? '国外' : '国内' }}</a-tag></template>
        <template slot="status" slot-scope="t,r"><a-switch :checked="Number(r.status === undefined ? r.enabled : r.status) === 1" @change="v => toggle(r,v)" /></template>
        <template slot="time" slot-scope="t,r">{{ r.last_time ? new Date(Number(r.last_time)*1000).toLocaleString() : '-' }}</template>
        <template slot="op" slot-scope="t,r"><a @click="edit(r)">编辑</a><a-divider type="vertical" /><a-popconfirm title="确认删除？" @confirm="remove(r)"><a class="danger">删除</a></a-popconfirm></template>
      </a-table>
      <a-modal :title="regionLabel + '热搜关键词'" :visible="visible" @ok="save" @cancel="visible=false">
        <a-form-model :model="form" :label-col="{span:6}" :wrapper-col="{span:16}">
          <a-form-model-item label="中文关键词"><a-input v-model="form.keyword" /></a-form-model-item>
          <a-form-model-item label="英文关键词"><a-input v-model="form.keywordEn" /></a-form-model-item>
          <a-form-model-item label="所属区域">{{ regionLabel }}</a-form-model-item>
          <a-form-model-item label="状态"><a-switch v-model="enabled" /></a-form-model-item>
          <a-form-model-item label="排序"><a-input-number v-model="form.sort" :min="0" /></a-form-model-item>
        </a-form-model>
      </a-modal>
    </a-card>
  </page-header-wrapper>
</template>
<script>
import { listSearchRecords, listHotSearch, saveHotSearch, setHotSearchStatus, removeHotSearch } from '@/api/dkmall/search'
export default {
  name: 'DkMallSearch',
  data() {
    return { loading: false, rows: [], visible: false, selectedRegion: 1, requestVersion: 0, query: {}, form: {} }
  },
  computed: {
    hot() { return this.$route.path.toLowerCase().includes('hot-search') },
    routeRegion() {
      const path = this.$route.path.toLowerCase()
      if (path.endsWith('/international')) return 2
      if (path.endsWith('/domestic')) return 1
      return null
    },
    currentRegion() { return this.routeRegion || this.selectedRegion },
    regionLabel() { return this.currentRegion === 2 ? '国外' : '国内' },
    enabled: {
      get() { return this.form.status === 1 },
      set(v) { this.form.status = v ? 1 : 0 }
    },
    columns() {
      return this.hot ? [
        { title: '中文关键词', dataIndex: 'key_word' },
        { title: '英文关键词', dataIndex: 'key_word_en' },
        { title: '搜索量', dataIndex: 'search_volume' },
        { title: '状态', scopedSlots: { customRender: 'status' } },
        { title: '操作', scopedSlots: { customRender: 'op' } }
      ] : [
        { title: '关键词', dataIndex: 'key_word' },
        { title: '英文', dataIndex: 'key_word_en' },
        { title: '搜索次数', dataIndex: 'search_count' },
        { title: '用户数', dataIndex: 'user_count' },
        { title: '国内/国外', scopedSlots: { customRender: 'region' } },
        { title: '最近搜索', scopedSlots: { customRender: 'time' } }
      ]
    }
  },
  watch: {
    '$route.fullPath'() { this.visible = false; this.load() },
    selectedRegion() { this.visible = false }
  },
  created() { this.load() },
  methods: {
    load() {
      const version = ++this.requestVersion
      const params = this.hot ? { ...this.query, region: this.currentRegion } : { ...this.query }
      this.loading = true
      this.rows = []
      return (this.hot ? listHotSearch(params) : listSearchRecords(params)).then(r => {
        if (version !== this.requestVersion) return
        this.rows = (r.data || []).map((x, i) => ({ ...x, rowKey: `${x.region}-${x.key_word}-${i}` }))
      }).finally(() => { if (version === this.requestVersion) this.loading = false })
    },
    openAdd() {
      this.form = { oldKeyword: '', oldRegion: this.currentRegion, keyword: '', keywordEn: '', region: this.currentRegion, status: 1, sort: 100 }
      this.visible = true
    },
    edit(r) {
      this.form = { oldKeyword: r.key_word, oldRegion: Number(r.region), keyword: r.key_word, keywordEn: r.key_word_en || '', region: this.currentRegion, status: Number(r.status), sort: Number(r.sort === undefined ? 100 : r.sort) }
      this.visible = true
    },
    save() {
      return saveHotSearch({ ...this.form, region: this.currentRegion }).then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.load()
      })
    },
    toggle(r, v) { return setHotSearchStatus(r.key_word, r.region, v).then(() => this.load()) },
    remove(r) { return removeHotSearch(r.key_word, r.region).then(() => this.load()) }
  }
}
</script>
<style scoped>
.bar { margin-bottom: 16px }
.ml { margin-left: 8px }
.danger { color: #f5222d }
</style>
